require('./cmHeaderSubPage.scss');

const PropTypes = require('prop-types');

// @ vendors
const React = require('react');
const classnames = require('classnames');

// @ commons
const { FormattedText, hasTranslation } = require('core/i18n').i18n;
const { OKBreadcrumb } = require('commonsComponents/OKBreadcrumb');
const EditAlias = require('commonsComponents/editAlias');

// @constants
const {
    CM_ICON_ERROR,
    CM_ICON_SUCCESS,
} = require('wealth-cm/constants/constants');

class CmHeaderSubPage extends React.Component {
    render() {
        const {
            hidden,
            titleKey,
            titleStrings,
            titleIsEditable,
            titleEditable,
            titleEditableAction,
            breadcrumbConfig,
            children,
            subtitleLeft,
            typeError,
        } = this.props;
        const classNames = classnames('cm-header-sub-page', {
            'cm-header-sub-page--hidden': hidden,
        });
        let titleContent;
        const subtitleSectionClass = classnames(
            'cm-header-sub-page__title-section',
            {
                'col-xs-5': children,
                'col-xs-12': !children,
            },
        );
        const headerTitleClasses = classnames('cm-header-sub-page__title', {
            'ok-header-sub-page__title--oneline': !subtitleLeft,
        });
        let { tutorial } = this.props;
        const type = typeError ? CM_ICON_ERROR : CM_ICON_SUCCESS;

        if (titleIsEditable) {
            titleContent = (
                <h1 className={headerTitleClasses}>
                    <EditAlias
                        alias={titleEditable}
                        postAlias={titleEditableAction}
                    />
                </h1>
            );
        } else {
            let finalTitle;
            if (!!titleKey) {
                if (hasTranslation(titleKey)) {
                    finalTitle = (
                        <FormattedText
                            value={titleKey}
                            injectedStrings={titleStrings}
                        />
                    );
                } else {
                    finalTitle = titleKey;
                }
            }
            titleContent = <h1 className={headerTitleClasses}>{finalTitle}</h1>;
        }

        return (
            <div className={classNames}>
                <div className="cm-header-sub-page__breadcrumb-section">
                    <OKBreadcrumb mapping={breadcrumbConfig} />
                </div>
                <div className="row no-gutter cm-header-sub-page__middle-section">
                    <i
                        className={`cm-header-sub-page--icon icon icon-${type}`}
                    />
                    <div className={subtitleSectionClass}>
                        <span className="cm-header-sub-page__success-icon" />
                        {titleContent}
                        <div className="cm-header-sub-page__wrapper-fix-tutorial">
                            {tutorial}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

CmHeaderSubPage.propTypes = {
    breadcrumbConfig: PropTypes.array.isRequired,
    titleKey: PropTypes.string,
    subtitleLeft: PropTypes.string,
    subtitleRight: PropTypes.any,
    children: PropTypes.any,
    titleStrings: PropTypes.array,
    titleIsEditable: PropTypes.bool,
    titleEditable: PropTypes.string,
    titleEditableAction: PropTypes.func,
    hidden: PropTypes.bool,
    isSubtitleLeftCapital: PropTypes.bool,
    tutorial: PropTypes.element,
    typeError: PropTypes.bool,
};

CmHeaderSubPage.defaultProps = {
    subtitleLeft: '',
    subtitleRight: '',
    titleStrings: [],
    titleIsEditable: false,
    hidden: false,
    isSubtitleLeftCapital: true,
};

module.exports = CmHeaderSubPage;
